var timestamp = new Date().getTime();
$('img.gif').attr('src', '//cdn.shopify.com/s/files/1/0421/6461/t/1/assets/logo_anim.gif?v=43796362121509300041418143467'+'?'+timestamp);
jQuery(document).ready(function($){
    var timestamp = new Date().getTime();
    setTimeout(function() {
        $($('img.hide')).fadeTo('slow', 1);
    }, 4000);

    $('.front-nav .nav li').each(function(index, val) {
        $(this).delay(300*index).fadeTo('slow', 1 ,function(){
            if (index == $('.front-nav .nav li').length - 1) {
                $('.placeholder').fadeTo('slow', 1);
            }
        });
    });
});
